module.exports = __webpack_public_path__ + "media/images/word-ai-logo-cdce3a8a.png";